import { useCallback, useRef } from 'react';
import { deferExecution } from 'utility/defer';

export const useMenuScroller = (callback?: () => void) => {
  const menuRef = useRef<any>(null);

  const onMenuOpen = useCallback(() => {
    deferExecution(() => {
      const halfHeight = window.innerHeight / 2;
      const inputRect =
        menuRef.current?.select?.inputRef?.getBoundingClientRect();

      if (inputRect && inputRect.top > halfHeight) {
        menuRef.current?.select?.inputRef?.scrollIntoView(true);
      }
    });

    callback?.();
  }, [callback]);

  return {
    ref: menuRef,
    onMenuOpen,
    menuInline: true,
  };
};
